interface Props {
  eyebrow: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
}

export default function SectionHeading({ eyebrow, title, desc, align = "left" }: Props) {
  const center = align === "center";
  return (
    <div className={center ? "flex flex-col items-center text-center" : ""}>
      <p className="font-label text-[11px] uppercase tracking-[0.25em] text-accent-600">
        / {eyebrow}
      </p>
      <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-snug">
        {title}
      </h2>
      {desc && (
        <p
          className={`mt-4 max-w-2xl text-sm md:text-base leading-relaxed text-foreground-600 ${
            center ? "mx-auto" : ""
          }`}
        >
          {desc}
        </p>
      )}
    </div>
  );
}